import React from 'react'
import { CHART_CONST_INFO } from '../../constants/common/chart/chartConst';

function SegmentBy(props: { selectedReport: string, segmentBy: string, setSegmentBy: Function, isDrillDownActive: boolean, showAssigneeSegment?: boolean }) {
    const { selectedReport, segmentBy, setSegmentBy, isDrillDownActive, showAssigneeSegment = false } = props;
    const firstOption = selectedReport === CHART_CONST_INFO.UPCOMING_DUE_DATES ? CHART_CONST_INFO.TAB_STATUS : CHART_CONST_INFO.WORKGROUP;
    const secondOption = selectedReport === CHART_CONST_INFO.UPCOMING_DUE_DATES ? CHART_CONST_INFO.TAB_DUE_DATE : CHART_CONST_INFO.ASSIGNEE;
    return (
        <div className='--segment-by'>
            <fieldset>
                <div className='--legend-container'>
                    <span><strong>{CHART_CONST_INFO.SEGMENT_BY}</strong></span>
                </div>
                <div className='--radio-button-container'>
                    <div className='--radio-button'>
                        <table>
                            <tr>
                                <td><label htmlFor="status">{firstOption}</label></td>
                                <td><input type="radio" id={firstOption} name="segment_by" value={firstOption} disabled={isDrillDownActive} checked={segmentBy === firstOption} onClick={() => { setSegmentBy(firstOption) }} /></td>
                            </tr>
                        </table>
                    </div>
                    {(selectedReport === CHART_CONST_INFO.UPCOMING_DUE_DATES || showAssigneeSegment) &&
                        <div className='--radio-button'>
                            <table>
                                <tr>
                                    <td><label htmlFor="due_date">{secondOption}</label></td>
                                    <td><input type="radio" id={secondOption} name="segment_by" value={secondOption} disabled={isDrillDownActive} checked={segmentBy === secondOption} onClick={() => { setSegmentBy(secondOption) }} /></td>
                                </tr>
                            </table>
                        </div>
                    }
                </div>
            </fieldset>
        </div>
    )
}

export default SegmentBy;